import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { STATUS_API, PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';
import { makeStyles } from '@material-ui/core';
import { getListCustomer, resetChange } from 'src/features/customerSlice';
import Toolbar from './ToolBar';
import Result from './Result';
import { getListProvinces } from 'src/features/provinceSlice';
import { getListAgencyBusiness } from 'src/features/agencySlice';
import { GetAgencyWallet } from 'src/features/authSlice';

const CustomerTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const query = useQuery();

  const listCustomer = useSelector(state => state.customerSlice.listCustomer);
  const totalCustomer = useSelector(state => state.customerSlice.totalCustomer);
  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);
  const listAgencyBusiness = useSelector(state => state.agencySlice.listAgencyBusiness);
  const statusCreate = useSelector(state => state.customerSlice.statusCreate);
  const { agencyId, isSale, isLeadMarketing } = useSelector(state => state.authSlice);
  const isSaleScope = Boolean(isSale || isLeadMarketing);
  const prevStatusCreateRef = useRef(statusCreate);

  const params = useMemo(() => {
    return {
      page: query.get('page') || 1,
      page_size: PAGE_SIZE_LIST,
      keywords: query.get('keywords') || undefined
    };
  }, [query]);

  const getListCustomersWithParams = useCallback(queryParams => {
    navigate('/app/manage/customers?' + _convertObjectToQuery(queryParams));
  }, [navigate]);

  useEffect(() => {
    if (!agencyId && !isSaleScope) return;
    dispatch(getListCustomer(params));
  }, [agencyId, isSaleScope, dispatch, params]);

  useEffect(() => {
    if (!agencyId && !isSaleScope) return;
    dispatch(getListProvinces());
    dispatch(getListAgencyBusiness());
  }, [agencyId, isSaleScope, dispatch]);

  // Đồng bộ lại cờ allow_edit_customer (admin có thể vừa bật/tắt)
  useEffect(() => {
    if (agencyId) dispatch(GetAgencyWallet(agencyId));
  }, [agencyId, dispatch]);

  useEffect(() => {
    if (
      prevStatusCreateRef.current !== STATUS_API.SUCCESS &&
      statusCreate === STATUS_API.SUCCESS
    ) {
      dispatch(getListCustomer(params));
      dispatch(resetChange());
    }

    prevStatusCreateRef.current = statusCreate;
  }, [dispatch, params, statusCreate]);

  useEffect(() => {
    return () => {
      dispatch(resetChange());
    };
  }, [dispatch]);

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          <Toolbar 
            searchRef={getListCustomersWithParams} 
            listProvinces={listProvinces}
            listAgencyBusiness={listAgencyBusiness}
          />

          <Result
            className="mt-3"
            listCustomer={listCustomer}
            totalCustomer={totalCustomer}
            getListCustomerRef={getListCustomersWithParams}
            currentParams={params}
          />
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    marginTop: '17px'
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

export default CustomerTable;
